/**
 * class that makes custom switchery checkboxes
 *
 * @param el - a checkbox which will be customized
 */

export class SwitcheryCustom{

    constructor(el){

        this.switchery = el;
        this.input = $(el).find('input');
        this.label = $(el).find('label');
        this.jack = $(el).find('span');
    }

    /**
     * init function
     */
    init(){
        let _this = this;

        this.getDataFromAttributes(_this.switchery);
        _this.defineStyles(_this.switchery);

        $('body').on('change', _this.input, function () {
            _this.defineStyles(_this.switchery);
        });
    }

    /**
     *gets custom styles from data attributes
     *
     * @param el - block on which switchery is initialized
     */
    getDataFromAttributes(el){

        let labelWidth = $(el).data('width');
        let labelHeight = $(el).data('height');
        let labelColorDisabled = $(el).data('background-disabled');
        let jackWidth = $(el).data('jack-width');
        let jackColor = $(el).data('jack-color');

        let additionalLabelStyles = {
            "width": labelWidth,
            "height": labelHeight,
            "background": labelColorDisabled
        };

        let additionalJackStyles = {
            "width": jackWidth,
            "background": jackColor
        };

        this.putCustomStyles(additionalLabelStyles, additionalJackStyles);
    }

    /**
     * adds styles from data attributes to a switchery element
     *
     * @param stylesLabel - styles for label
     * @param stylesJack - styles for jack
     */
    putCustomStyles(stylesLabel, stylesJack){

        $(this.label).css(stylesLabel);
        $(this.jack).css(stylesJack);
    }

    /**
     * changes switchery element's styles according to the input state
     *
     * @param el - block on which switchery is initialized
     */
    defineStyles(el){

        let labelColor = $(el).data('background');
        let labelColorDisabled = $(el).data('background-disabled');
        let currentInput = $(el).find('input');

        if(currentInput[0].checked === true) {

            $(this.label).css({
                "background": labelColor,
                "border": `1px solid ${labelColor}`,
                "box-shadow": `${labelColor} 0px 0px 0px 16.6667px inset`
            });
        } else{

            $(this.label).css({
                "background": labelColorDisabled,
                "border": "1px solid #ccc",
                "box-shadow": `${labelColorDisabled} 0px 0px 0px 0px inset`
            });
        }
    }


}


// WEBPACK FOOTER //
// ./js/script/components/switchery.js